import { Card, CardDescription, CardHeader, CardTitle, PageHeader } from '@berky/ui'
import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router'

import { settingsSections } from './settings-sections'

export function SettingsOverviewPage() {
  return (
    <>
      <PageHeader
        title="Einstellungen"
        description="Wählen Sie einen Bereich, um die Einstellungen der Plattform zu verwalten."
      />
      <ul
        className="grid gap-4 md:grid-cols-2 xl:grid-cols-3"
        aria-label="Einstellungsbereiche"
      >
        {settingsSections.map(({ path, title, description, Icon }) => (
          <li key={path}>
            <Link
              to={path}
              className="group block h-full rounded-xl outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              <Card className="h-full shadow-xs transition-colors group-hover:border-primary/40 group-hover:bg-muted/20">
                <CardHeader>
                  <div className="mb-3 flex items-center justify-between gap-3">
                    <span className="flex size-10 items-center justify-center rounded-lg bg-muted text-primary">
                      <Icon className="size-5" aria-hidden="true" />
                    </span>
                    <ChevronRight
                      className="size-4 text-muted-foreground"
                      aria-hidden="true"
                    />
                  </div>
                  <CardTitle>
                    <h2 className="text-base">{title}</h2>
                  </CardTitle>
                  <CardDescription>{description}</CardDescription>
                </CardHeader>
              </Card>
            </Link>
          </li>
        ))}
      </ul>
    </>
  )
}
